var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.6413 12.6552L13.1704 10.1784C12.6782 9.6871 11.8632 9.70203 11.3538 10.2127L10.109 11.4601C10.0303 11.4167 9.94891 11.3713 9.86332 11.3231C9.07719 10.8866 8.00124 10.2882 6.86903 9.15259C5.73347 8.01458 5.1359 6.93454 4.69898 6.14613C4.65288 6.0626 4.6087 5.98207 4.56508 5.90559L5.40057 5.06945L5.81133 4.65725C6.32143 4.14586 6.33549 3.32921 5.84448 2.83648L3.37353 0.359373C2.88251 -0.132666 2.0671 -0.117739 1.55701 0.39365L0.860608 1.09563L0.879638 1.11457C0.646127 1.4132 0.450997 1.75763 0.305788 2.12905C0.171932 2.4826 0.0885942 2.81998 0.0504876 3.15805C-0.275785 5.86906 0.960265 8.34671 4.31474 11.7088C8.95165 16.3559 12.6884 16.0049 12.8496 15.9877C13.2007 15.9457 13.5372 15.8616 13.8791 15.7285C14.2465 15.5847 14.5899 15.3894 14.8877 15.1558L14.9029 15.1694L15.6084 14.477C16.1174 13.9657 16.1321 13.1487 15.6413 12.6552Z",
    fill: "#777777"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallGrey);
export default __webpack_public_path__ + "static/media/call-grey.254605ea8bd508df3248b38d5f58102c.svg";
export { ForwardRef as ReactComponent };